import { render } from "./KanaList.vue?vue&type=template&id=a24515f6&scoped=true&ts=true"
import script from "./KanaList.vue?vue&type=script&lang=ts"
export * from "./KanaList.vue?vue&type=script&lang=ts"

import "./KanaList.vue?vue&type=style&index=0&id=a24515f6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a24515f6"]])

export default __exports__